import ArrowWithTail from "../../../assets/icons/ArrowWithTail";
import classes from "./NewsPlatforms.module.scss";
import { Link } from "react-router-dom";
import seNewsLogo from "../../../assets/icons/seNewsLogo.svg";
import ngAiNewsLogo from "../../../assets/icons/ngAiNewsLogo.svg";

const newsContent = [
  {
    imgSrc: seNewsLogo,
    title: "Sustainability Economics News",
    description:
      "Explore in-depth coverage of global sustainability trends, providing insights into clean energy, climate policies, and industry transitions.",
    linkText: "Go to SEN",
    linkUrl: "https://sustainabilityeconomicsnews.com/",
  },
  {
    imgSrc: ngAiNewsLogo,
    title: "NextGen.ai News",
    description:
      "Find comprehensive 360 degree AI-focused reporting, covering breakthroughs, and the evolving landscape of artificial intelligence.",
    linkText: "Go to NextGen.ai",
    linkUrl: "https://ngainews.com/",
  },
];

function NewsPlatforms() {
  return (
    <div className={classes.container}>
      <div className={classes.title}>
        Our <br /> <span>News Platforms</span>
      </div>

      <div className={classes["news-imgs-container"]}>
        {newsContent.map((news, index) => (
          <div key={index} className={classes["news-img-card"]}>
            <div className={classes["img-content-container"]}>
              <img
                src={news.imgSrc}
                alt={news.title}
                className={classes["news-img"]}
              />
              <div className={classes["news-content"]}>
                <div className={classes["news-title"]}>{news.title}</div>
                <div className={classes["description"]}>{news.description}</div>
                <Link
                  to={news.linkUrl}
                  rel="noopener noreferrer"
                  className={classes["link"]}
                  target="_blank"
                >
                  {news.linkText} <ArrowWithTail color="#106666" />
                </Link>
              </div>
            </div>

            {/* <div className={classes["background-box"]}></div> */}
          </div>
        ))}
      </div>
    </div>
  );
}

export default NewsPlatforms;
